import { Phone, CalendarCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Reveal } from './motion';
import { SITE } from '../data/site';

export default function CTABand({ heading = 'Schedule HVAC or Plumbing Service Today', text, testid = 'cta-band' }) {
  return (
    <section className="relative overflow-hidden bg-navy py-16 grain lg:py-20" data-testid={testid}>
      <div className="absolute -left-24 top-0 h-full w-72 -skew-x-12 bg-brand/20" aria-hidden="true" />
      <div className="absolute -right-16 bottom-0 h-full w-56 -skew-x-12 bg-skyaccent/10" aria-hidden="true" />
      <div className="relative mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-4 sm:px-6 lg:flex-row lg:items-center lg:px-12">
        <Reveal className="max-w-2xl">
          <h2 className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">{heading}</h2>
          <p className="mt-3 text-base leading-relaxed text-slate-300 sm:text-lg">
            {text || `Talk to a local team with over 60 years of experience. Call ${SITE.phone} or request service online and we will follow up fast.`}
          </p>
        </Reveal>
        <Reveal delay={0.15} className="flex flex-col gap-3 sm:flex-row">
          <a
            href={SITE.phoneHref}
            data-testid={`${testid}-call-button`}
            className="flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 font-display text-base font-bold text-navy transition-all hover:-translate-y-0.5 hover:bg-sky-100"
          >
            <Phone className="h-5 w-5 text-brand" /> Call {SITE.phone}
          </a>
          <Link
            to="/contact"
            data-testid={`${testid}-schedule-button`}
            className="flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 font-display text-base font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-brand-dark"
          >
            <CalendarCheck className="h-5 w-5" /> Schedule Service
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
